import React, { useState } from "react";
import { Checkbox, TextField, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
// import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { createUser, getGroupUsers, getDepartment, getCustomers, getOrganizationData } from "./../../../services/api";
import { FilterBy } from "./../../commons/filter.component";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";

const CreateUser = ({ open, onCreateResponse, onClose }) => {
  const [t] = useTranslation();
  const [inputData, setInputData] = useState({
    name: "",
    email: "",
    organization: null,
    usergroup: null,
    customer: null,
    password: "",
    confirmPassword: "",
    department: null,
  });
  const [isCustomer, setIsCustomer] = useState(false);
  const handleCreateUser = () => {
    let data = {};
    if (!isCustomer)
      data = {
        name: inputData.name,
        email: inputData.email,
        organization_id: inputData.organization?.id,
        usergroup_id: inputData.usergroup?.id,
        password: inputData.password,
        password_confirmation: inputData.confirmPassword,
        department_id: inputData.department?.id,
      };
    else
      data = {
        name: inputData.name,
        email: inputData.email,
        customer_id: inputData.customer?.id,
        password: inputData.password,
        password_confirmation: inputData.confirmPassword,
        usergroup_id: inputData.usergroup?.id,
      };
    return createUser(data);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle align="center">{t("Thêm mới người dùng")}</DialogTitle>
      <DialogContent align="center" dividers>
        <TextField label={t("Tên người dùng")} value={inputData.name} onChange={(e) => setInputData((prev) => ({ ...prev, name: e.target.value }))} fullWidth style={{ margin: "5px 0" }} />
        <TextField label="Email" value={inputData.email} onChange={(e) => setInputData((prev) => ({ ...prev, email: e.target.value }))} fullWidth style={{ margin: "5px 0" }} />
        <div style={{ display: "flex" }}>
          <Checkbox checked={isCustomer} onClick={() => setIsCustomer((prev) => !prev)} />
          <div style={{ margin: "auto 0" }}>{t("Là khách hàng")} ?</div>
        </div>
        {!isCustomer && (
          <FilterBy
            label="Tổ chức"
            getDataFunc={() => getOrganizationData({ status: 1 })}
            value={inputData.organization}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, organization: newValue, department: null }))}
            style={{ width: "100%", margin: "5px 0 10px" }}
          />
        )}
        {isCustomer && (
          <FilterBy
            label="Khách hàng"
            getDataFunc={() => getCustomers({ status: 1 })}
            value={inputData.customer}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, customer: newValue }))}
            style={{ width: "100%", margin: "5px 0 10px" }}
          />
        )}
        {!isCustomer && (
          <FilterBy
            disabled={!inputData.organization && !isCustomer}
            getDataFunc={() => getDepartment({ params: { status: 1 } })}
            label={t("Phòng ban")}
            value={inputData.department}
            filter={(option) => option.organization_id === inputData.organization?.id}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, department: newValue }))}
            style={{ margin: "5px 0 10px" }}
          />
        )}
        <FilterBy
          label={t("Nhóm người dùng")}
          getDataFunc={() => getGroupUsers({ status: 1 })}
          value={inputData.usergroup}
          onChange={(e, newValue) => setInputData((prev) => ({ ...prev, usergroup: newValue }))}
          style={{ margin: "5px 0" }}
        />
        <TextField label={t("password")} type="password" onChange={(e) => setInputData((prev) => ({ ...prev, password: e.target.value }))} fullWidth style={{ margin: "5px 0" }} />
        <TextField label={t("confirm_password")} type="password" onChange={(e) => setInputData((prev) => ({ ...prev, confirmPassword: e.target.value }))} fullWidth style={{ margin: "5px 0" }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICallComponent variant="contained" api={handleCreateUser} response={onCreateResponse}>
          {t("Tạo mới")}
        </ButtonWithAPICallComponent>
      </DialogActions>
    </Dialog>
  );
};

export default CreateUser;
